import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import I18nLink from '../../i18n/Link'

class FooterNav extends PureComponent {
  static propTypes = {
    menuNav: PropTypes.array,
    vacanciesLink: PropTypes.string,
  }

  render() {
    const { menuNav, vacanciesLink } = this.props

    return (
      <ul>
        {menuNav.map(x => (
          <li key={`nav-${x.title}`}>
            <I18nLink to={x.href}>{x.title}</I18nLink>
          </li>
        ))}
        {vacanciesLink && (
          <li>
            <a href="https://hh.ru/employer/3159117" target="_blank" rel="noopener noreferrer">{vacanciesLink}</a>
          </li>
        )}
      </ul>
    )
  }
}

export default FooterNav
